const findColspan = (tokens, pos) => {
  const nextToken = tokens[pos + 1];

  return nextToken.type === 'inline' && nextToken.content === '>';
};

module.exports = function tableColspan(md) {
  md.core.ruler.push('table_colspan', function remover(state) {
    let spanCount = 1;
    let currentSpan = null;

    for (let i = 0; i < state.tokens.length; i++) {
      const token = state.tokens[i];
      if (token.type === 'td_open' || token.type === 'th_open' || token.type === 'tr_close') {
        if (findColspan(state.tokens, i)) {
          spanCount++;
          if (!currentSpan) {
            currentSpan = i;
          }

          continue;
        }

        if (!currentSpan) {
          spanCount = 1;
          continue;
        }

        if (token.type !== 'tr_close') {
          for (let j = currentSpan + 1; j <= i; j++) {
            state.tokens[j] = undefined;
          }
          if (!state.tokens[currentSpan].attrs) {
            state.tokens[currentSpan].attrs = [];
          }
          state.tokens[currentSpan].attrs.push(['colspan', spanCount]);
        }

        spanCount = 1;
        currentSpan = null;
      }
    }

    state.tokens = state.tokens.filter((v) => !!v);
  });
};
